import React, { FC } from 'react'

import clsx from 'clsx'

import { RankNumber } from '../../../components/RankNumber'

import {
  IJudge,
  IRegistrationByDayInterface,
} from '../../../../../../../models/registrations-by-day/registrationByDay.interface'

interface CustomScoringTotalProps {
  judge: IJudge
  row: IRegistrationByDayInterface
  handleModalOpen?: () => void
  index: number
}

export const CustomScoringTotal: FC<CustomScoringTotalProps> = ({
  judge,
  row,
  handleModalOpen,
  index,
}) => {
  return (
    <div
      className={clsx(
        'flex items-center md:ml-auto md:text-right gap-2.5 transition-all',
        handleModalOpen && 'cursor-pointer hover:opacity-70'
      )}
      onClick={handleModalOpen}
    >
      <div className="flex flex-col">
        {judge?.isWithdrew
          ? 'Withdrew'
          : judge?.customSections?.map((section) => {
              const showSection = section.type !== 'jump off' || judge.showJumpOff
              return (
                showSection && (
                  <div
                    key={section.id}
                    className="whitespace-nowrap flex items-center gap-2 text-right justify-end"
                  >
                    <p className="font-bold">{section.totalFaultsStatus || section.totalTime} •</p>{' '}
                    <p>
                      {section.totalFaultsCount ?? 0}F / {section.totalTimeFaults ?? 0}
                      TF
                    </p>
                  </div>
                )
              )
            })}
      </div>
      <RankNumber
        rank={Number(row.score?.rank) || index + 1}
        totalPoints={row.score?.totalPoints}
      />
    </div>
  )
}
